import { Dimensions, Platform } from 'react-native';

const width = () => Dimensions.get('window').width;
export const minDesktopWidth = 550;

export const isSmall = width() <= 550;
export const isMedium = width() >= 992 && width() <= 1200;
export const isLarge = width() >= 1200;

export const isMobile = () => width() < minDesktopWidth;
export const isMobileWeb = () => isMobile() && Platform.OS === 'web';
export const isDesktop = () => Platform.OS === 'web' && !isMobile();

export const isWeb = () => Platform.OS === 'web';

export function selectBasedOnScreenWidth<T>(checks: Record<number | 'fallback', T>): T {
  const widthsToCheck = Object.keys(checks)
    .map((key: string) => Number(key))
    .filter((key: number) => Number.isInteger(key));

  const actualWidth = width();
  const smallestMatch = widthsToCheck.sort().find((checkWidth: number) => actualWidth < checkWidth);
  if (smallestMatch) {
    return checks[smallestMatch] || checks.fallback;
  }
  return checks.fallback;
}
